const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const startGoogleSignIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const openBillingPortal = async () => {
  const res = await fetch(`${API}/billing/portal`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ origin_url: window.location.origin }),
  });
  if (!res.ok) throw new Error("portal failed");
  const data = await res.json();
  window.location.href = data.url;
};
